import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { bool, func, string } from "prop-types";
import FILTER_CALLBACKS from "../actions/constants";

import { addCreatedTasks, toggleModalAddTaskOpen, toggleTasksSelectionMode } from "../actions/creators";

import Button from "../../../../shared/v2/Button";
import Plus from "../../../../shared/v2/Icomoon/Icons/Plus";
import { ChevronDown } from "../../../../shared/v2/Icomoon";

import Drawer from "../Drawer";
import TaskModal from "../../../../Tasks/components/TaskModal";
import { createTask } from "../api/helpers";
import withFilters from "../HOCs/withFilters";

const HeaderOptions = ({
  filtered,
  isModalAddTaskOpen,
  isTasksSelectionMode,
  onToggleModalAddTaskOpen,
  onToggleTasksSelectionMode,
  taskFilters,
  uuid,
}) => {
  const dispatch = useDispatch();
  const [isDrawerOpen, toggleDrawer] = useState(false);

  return (
    <div className="tw-ml-auto tw-flex tw-justify-end">
      {isModalAddTaskOpen && (
        <TaskModal
          v4TaskApi
          listingUuid={uuid}
          taskable={{ uuid, taskable_type: "Listing" }}
          onClose={(newTask) => {
            if (newTask) {
              dispatch(addCreatedTasks([createTask(newTask)]));
              if (taskFilters) dispatch(FILTER_CALLBACKS[taskFilters]());
            }
            onToggleModalAddTaskOpen(false);
          }}
        />
      )}
      <div className="tw-h-[24px] tw-flex">
        <Button
          className="tw-h-full tw-py-0 tw-mr-[8px]"
          schema="tertiary"
          onClick={onToggleTasksSelectionMode}
        >
          {isTasksSelectionMode ? "Cancel" : "Select Tasks"}
        </Button>
        <Button
          disabled={isTasksSelectionMode}
          className="tw-py-0 tw-mr-[8px]"
          schema={!filtered ? "tertiary" : "primary"}
          onClick={() => toggleDrawer((prev) => !prev)}
        >
          <span>{!filtered ? "Filter" : "Filtered "}</span>
          {filtered && <ChevronDown size="s" />}
        </Button>
        <Button
          disabled={isTasksSelectionMode}
          className="tw-w-[24px] tw-flex tw-items-center tw-justify-center"
          schema="tertiary"
          onClick={() => {
            toggleDrawer(false);
            onToggleModalAddTaskOpen((prev) => !prev);
          }}
        >
          <Plus size="s" />
        </Button>
      </div>
      <Drawer show={isDrawerOpen} toggleDrawer={toggleDrawer} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  filtered: state.tdpTasksReducer.filtered,
  isModalAddTaskOpen: state.tdpTasksReducer.isModalAddTaskOpen,
  isTasksSelectionMode: state.tdpTasksReducer.isTasksSelectionMode,
  uuid: state.tdpTasksReducer.uuid,
});

const mapDispatchToProps = (dispatch) => ({
  onToggleModalAddTaskOpen: (boolean) => dispatch(toggleModalAddTaskOpen(boolean)),
  onToggleTasksSelectionMode: () => dispatch(toggleTasksSelectionMode()),
});

HeaderOptions.propTypes = {
  filtered: bool,
  isModalAddTaskOpen: bool,
  isTasksSelectionMode: bool,
  onToggleModalAddTaskOpen: func,
  onToggleTasksSelectionMode: func,
  taskFilters: string,
  uuid: string.isRequired,
};

HeaderOptions.defaultProps = {
  filtered: false,
  isModalAddTaskOpen: false,
  isTasksSelectionMode: false,
  onToggleModalAddTaskOpen: null,
  onToggleTasksSelectionMode: null,
  taskFilters: "",
};

export default connect(mapStateToProps, mapDispatchToProps)(withFilters(HeaderOptions));
